import { GRID_TYPES } from '../hooks/useGridInputs';

const GRID_TYPE_LABELS = {
  [GRID_TYPES.BUILDER_CONSTRUCTOR_GRID]: 'CIO Browse',
  [GRID_TYPES.CONSTRUCTOR_SEARCH_GRID]: 'CIO Search',
  [GRID_TYPES.PRODUCTS_V2_GRID]: 'Products/v2',
};

/**
 * Get tracking tags for the grid layout.
 *
 * @param {Object} params - The parameters for the function.
 * @param {number} params.totalNumResults - The total number of results.
 * @param {string} params.cioFilterName - The name of the filter applied.
 * @param {string} params.cioFilterValue - The value of the filter applied.
 * @param {string} params.gridType - The type of the grid (e.g., 'BUILDER_CONSTRUCTOR_GRID').
 * @returns {Object} - An object containing the tracking tags.
 */
export const getGridLayoutTrackingTags = ({
  totalNumResults,
  cioFilterName,
  cioFilterValue,
  gridType,
}) => {
  const trackingTags = {
    ...(gridType === GRID_TYPES.BUILDER_CONSTRUCTOR_GRID && {
      'data-cnstrc-browse': '',
    }),
    ...(gridType === GRID_TYPES.CONSTRUCTOR_SEARCH_GRID && {
      'data-cnstrc-search': '',
    }),
    'data-cnstrc-num-results': totalNumResults,
    'data-cnstrc-filter-name': cioFilterName,
    'data-cnstrc-filter-value': cioFilterValue,
    'data-autotag': 'prodgrid',
    'data-grid-version': `${GRID_TYPE_LABELS[gridType]} v2`,
  };

  return {
    trackingTags,
  };
};
